<script setup>
const route = useRoute()
const mapName = 'okinawa'
if (route.path !== `/${mapName}/`) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('pref', getFullPrefectureName(mapName))
const breadCrumbList = getBreadCrumb(mapName)
const [pickupLivecamList, prefLivecamList] = await Promise.all([
  useFetch('/api/livecam/pickuplist', { query: { target: mapName } }),
  useFetch('/api/livecam/pointlist', { query: { target: mapName } })
]).then((responses) => responses.map((res) => res.data))
const { sortPickupLivecamList, sortRemainingPreflist } = sortPrefLivecamData(pickupLivecamList.value, prefLivecamList.value)
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <CommonPageTitle :title="`${getPrefectureName(mapName)}のライブカメラ`" />
        <LivecamList :list="sortPickupLivecamList" />
        <LivecamPointList
          v-if="sortRemainingPreflist.length!==0"
          :list="sortRemainingPreflist"
        />
      </div>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
